module.exports = __webpack_public_path__ + "static/media/play.5d81c022.svg";